import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { ProtocoloConsultaEmpresa, StatusProtocoloEmpresa } from 'src/app/model/protocolo-consulta-empresa.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';
import { ExportService } from 'src/app/shared/services/export.service';
import Utils from 'src/app/shared/fgi-utils';
import { ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import moment from "moment";
import { ProtocoloConsultaEmpresaService } from 'src/app/shared/services/protocolo-consulta-empresa.service';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-envio-consulta-protocolo-empresa',
    templateUrl: './envio-consulta-protocolo-empresa.component.html',
    styleUrls: ['./envio-consulta-protocolo-empresa.component.scss'],
    standalone: false
})
export class EnvioConsultaProtocoloEmpresaComponent implements OnInit {

  
  pesquisaForm: UntypedFormGroup;
  cnpjUsuario: string;
  cnpjSelecionado: string;
  statusSelecionado: StatusProtocoloEmpresa;

  agentesFinanceiros: AgenteFinanceiro[] = [];
  podeEscolherAgente = false;
  protocolosRenuncia: ProtocoloConsultaEmpresa[];
  public exibirComboTipoArquivo: Boolean = false;
  atributosPaginacaoComponenteListagem: EntityPagedResult<ProtocoloConsultaEmpresa>;
  private opcoesPaginacao: number[];
  private paramsAdicionados: any = {};

  private totalObjetosRetornados: number;


  constructor(
      private formBuilder: UntypedFormBuilder,
      private permissaoService: PermissaoService,
      private loadingService: BnLoadingService,
      private service: ProtocoloConsultaEmpresaService,
      private agenteService: AgenteFinanceiroService,
      private bnUsuarioService: BnUsuarioService,
      private el: ElementRef,
      private exportService: ExportService,
  ) {

  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
      this.buscar(false, true)
  }

  ngOnInit(): void {

      this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
          this.podeEscolherAgente = resp && resp[ROLE_GESTOR_CONSULTA];
      });

      this.construirFormulario();

      this.bnUsuarioService.usuario$.pipe(
            filter(usuario => !!usuario)
        ).subscribe(usuario => {
            this.cnpjUsuario = usuario.cnpj ? usuario.cnpj : 'BNDES';
            
            if (this.cnpjUsuario !== 'BNDES') {
                this.cnpjUsuario = usuario.cnpj;
                this.pesquisaForm.get('agenteFinanceiro').setValue(this.cnpjUsuario);
              }
        });

      this.opcoesPaginacao = [10, 15, 20];
      this.resetarListagem();
      
      this.buscarAgentesFinanceiros();
  }

  private resetarListagem() {
    this.atributosPaginacaoComponenteListagem = {
        page: 1,
        pageSize: this.opcoesPaginacao[0],
        pages: undefined,
        count: undefined,
        list: undefined
    };

    this.protocolosRenuncia = undefined;
  }

  private construirFormulario() {
      this.pesquisaForm = this.formBuilder.group({
          agenteFinanceiro: [''],
          statusProtocolo: [''],
          dataEnvioInicial: [''],
          dataEnvioFinal: [''],
          idSolicitacaoApiExterna: ['']
      });
  }

  private buscarAgentesFinanceiros() {
      this.agenteService.getAgentesFinanceirosNestaModalidade(true)
          .subscribe(agentes => {
              this.agentesFinanceiros = agentes;
          });
  }

  podePesquisar(): boolean {
      return true;
  }

  mudancaPagina(novaPagina: EntityPagedResult<ProtocoloConsultaEmpresa>) {
      this.atributosPaginacaoComponenteListagem = novaPagina;
      this.buscar(false, false);
  }


  compararPorId(item1: string, item2: string): boolean {
      return (item1 && item2) ? (item1 === item2) : (!item1 && !item2);
  }



  buscar(paginaVazia: boolean, voltarPagina1: boolean) {
      this.loadingService.bloqueiaTela();

      let cnpjFiltro = this.pesquisaForm.get('agenteFinanceiro').value;

      const statusProtocolo = this.pesquisaForm.get('statusProtocolo')?.value;

      const dataEnvioInicial: Date = this.pesquisaForm.get('dataEnvioInicial')?.value;
      const dataEnvioFinal: Date = this.pesquisaForm.get('dataEnvioFinal')?.value;

      const idSolicitacaoApiExt = this.pesquisaForm.get('idSolicitacaoApiExterna').value;

      /* preenchimento dos filtros */
      const params: any = {};

      if (cnpjFiltro) {
          params.cnpjAgente = cnpjFiltro;
      }

      if (statusProtocolo) {
          params.statusProtocolo = statusProtocolo;
      }

      if (dataEnvioInicial) {
          params.dataEnvioInicial = moment(dataEnvioInicial).format('YYYYMMDD');
      }

      if (dataEnvioFinal) {
          params.dataEnvioFinal = moment(dataEnvioFinal).format('YYYYMMDD');
      }

      if (idSolicitacaoApiExt) {
        params.idSolicitacaoApiExt = idSolicitacaoApiExt;
      }

      if (voltarPagina1) {
          this.atributosPaginacaoComponenteListagem.page = 1;
      }
      paginaVazia = Utils.verificaPaginaVazia(this.protocolosRenuncia, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
      if (paginaVazia && !voltarPagina1) {
          this.atributosPaginacaoComponenteListagem.page = this.atributosPaginacaoComponenteListagem.pages;
      }
      params.pagina = this.atributosPaginacaoComponenteListagem.page;
      params.limite = this.atributosPaginacaoComponenteListagem.pageSize;

      this.paramsAdicionados = params;

      this.service.getArquivosPorAgente(params)
          .subscribe(response => {
              console.log(response);
              this.protocolosRenuncia = response ? response.resultados : [];
              this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
              this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count;
              this.cnpjSelecionado = cnpjFiltro;
              this.loadingService.liberaTela();

              paginaVazia = Utils.verificaPaginaVazia(this.protocolosRenuncia, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
              if (paginaVazia && !voltarPagina1) {
                  this.buscar(false, true);
              }
          }, err => this.loadingService.liberaTela());
  }

  removeNgInvalidInput(id: string) {
      const inputElement = this.el.nativeElement.querySelector(`#${id}`);
      inputElement.classList.remove('ng-invalid');
    }
  

  limpar() {    
    this.resetarListagem();

     if(this.cnpjUsuario === 'BNDES'){
        this.pesquisaForm.reset();
        this.pesquisaForm.get('agenteFinanceiro').setValue(undefined);
     }

      this.pesquisaForm.get('statusProtocolo').setValue(undefined);
      this.pesquisaForm.get('dataEnvioInicial').setValue(undefined);
      this.pesquisaForm.get('dataEnvioFinal').setValue(undefined);
      this.pesquisaForm.get('idSolicitacaoApiExterna').setValue(undefined);

      setTimeout(() => {
          this.removeNgInvalidInput('dataEnvioInicial');
          this.removeNgInvalidInput('dataEnvioFinal');
        }, 100);
  }


  getParams(comDetalhes?: boolean): any {
      if (comDetalhes) {
          this.paramsAdicionados.comDetalhes = true;
          this.paramsAdicionados.limite = 5000;
          this.paramsAdicionados.pagina = 1;
      }

      return this.paramsAdicionados;
  }

  exportarProtocolos() {
    this.loadingService.bloqueiaTela();
    this.service.getDetalheExportar(this.getParams(false)).subscribe((resp) => {
       console.log(resp);
        this.exportService.exportarListaProtocolosEmpresa(resp);
    });
}
}
